import * as constants from './constants';
import { fetchFromRTMWithRetries } from '../RTMResolvers';

class AssetResolver {
  constructor(connection) {
    this.connection = connection;
  }

  async learnerAssetGet(urn) {
    const message = {
      type: constants.RTM_LEARNER_ASSET_GET,
      urn,
    };

    const response = await fetchFromRTMWithRetries(
      message,
      constants.RTM_LEARNER_ASSET_GET_OK,
      constants.RTM_LEARNER_ASSET_GET_ERROR
    );
    return response.asset;
  }
}

export default AssetResolver;
